
export * from "../node_modules/chart.js/dist/chart.mjs"